import { Component, computed, inject, input, output } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ItemDetailsService } from 'src/app/shared/services/item-details.service';
import { ItemPublicLinkComponent } from '../item-public-link/item-public-link.component';
import { lastValueFrom } from 'rxjs';
import { PricesDisplayComponent } from './item-summary-section/prices/prices.component';
import { ItemSummarySectionComponent } from './item-summary-section/item-summary-section.component';

@Component({
  selector: 'app-item-summary-tab',
  standalone: true,
  imports: [
    ItemPublicLinkComponent,
    NgxSkeletonLoaderModule,
    PricesDisplayComponent,
    ItemSummarySectionComponent
  ],
  providers: [ItemDetailsService],
  templateUrl: './item-summary-tab.component.html'
})
export class ItemSummaryTabComponent {
  itemDetailsService = inject(ItemDetailsService);
  itemId = input.required<number>();
  selectTab = output<string>();

  itemDetailsQuery = injectQuery(() => ({
    enabled: Boolean(this.itemId()),
    queryKey: ['itemDetails', this.itemId()],
    queryFn: () => lastValueFrom(this.itemDetailsService.get(this.itemId()))
  }));

  orderedSections = computed(() => {
    const itemDetails = this.itemDetailsQuery.data();
    if (!itemDetails) {
      return [];
    }
    const defaultOrder = [
      'deliveries',
      'hires',
      'bookings',
      'workshopJobs',
      'keyDetails'
    ];

    // show the sections that are not null or have a count of 0 first
    const sectionsWithData = defaultOrder.filter((section) => {
      if (section === 'deliveries') {
        return itemDetails.nextDelivery;
      }
      if (section === 'hires') {
        return itemDetails.currentHires.length > 0;
      }
      if (section === 'bookings') {
        return itemDetails.nextBooking;
      }
      if (section === 'workshopJobs') {
        return itemDetails.currentWorkshopJobs;
      }
      return false;
    });

    return [
      ...sectionsWithData,
      ...defaultOrder.filter((section) => !sectionsWithData.includes(section))
    ];
  });
}
